export interface BannerState {
  titleKey: string;
  contentKey: string;
  dismissed: boolean;
}
